import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/lib/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import Expertise from "@/pages/Expertise";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/despre" element={<About />} />
              <Route path="/about" element={<About />} />
              <Route path="/solutii" element={<Solutions />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/expertiza" element={<Expertise />} />
              <Route path="/expertise" element={<Expertise />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
